module.exports = __webpack_public_path__ + "static/media/iim-ahmedabad-logo.c0e63e14.png";